import { createStore } from 'vuex';
import global from './modules/global/global.index';
import apm from './modules/apm/apm.index';
import alarm from './modules/alarm/alarm.store';
import home from './modules/home/home.store';
import browser from './modules/browser/browser.index';
import vm from './modules/vm/vm.index';
import mobile from './modules/mobile/mobile.index';
import database from './modules/database/database.index';
import wsm from './modules/wsm/wsm.index';
import synthetic from './modules/synthetics/synthetics.index';
import k8 from './modules/k8/k8.index';
import cloud from './modules/cloud/cloud.index';
import channel from './modules/channel/channel.index';
import alertV2 from './modules/alertV2/alertV2.index';
import log from './modules/log/log.index';
import de from './modules/de/de.store';
import billing from './modules/billing/billing.store';
import mq from './modules/mq/mq.index';
import VuexPersistence from 'vuex-persist';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default createStore({
  namespaced: true,
  modules: {
    globalState: global,
    apmState: apm,
    alarmState: alarm,
    homeState: home,
    browserState: browser,
    vmState: vm,
    mobileState: mobile,
    databaseState: database,
    wsmState: wsm,
    syntheticState: synthetic,
    k8State: k8,
    cloudState: cloud,
    channelState: channel,
    alertV2State: alertV2,
    logState: log,
    deState: de,
    usageState: billing,
    mqState: mq,
  },
  plugins: [vuexLocal.plugin],
});
